import Api from '../api/common'

let RETRY_TIMES = {}
export default {
	updateGlobalVar({commit,dispatch},name){
		return new Promise((resolve,reject)=>{
			Api.getGlobalVar(name).then(data=>{
				commit('updateGlobalVar',{name:name,data:data})
				resolve(data)
			},msg=>{
				if(!RETRY_TIMES[name]){
					RETRY_TIMES[name] = 1
				}else{
					RETRY_TIMES[name]++
				}
				if(RETRY_TIMES[name] > 3){
					reject(msg)
				}else{
					dispatch('updateGlobalVar',name)
				}
				
			})
		})
	},
	getJssdkConfig({state,commit,dispatch},$wx){
		let name = 'jssdk'
		let now_time = Math.floor((new Date()).getTime()/1000)
		return new Promise((resolve,reject)=>{
			if(state.jssdk.ready && state.jssdk.request_time + state.jssdk.expire > now_time ){
				$wx.config(state.jssdk)
				resolve(state.jssdk)
			}else{
				Api.getWxJssdk(state.config.JSSDK_URL)
				.then(config=>{
					commit('updateJssdkConfig',config)
					$wx.config(config)
					resolve(config)
				},response=>{
					if(!RETRY_TIMES[name]){
						RETRY_TIMES[name] = 1
					}else{
						RETRY_TIMES[name]++
					}
					if(RETRY_TIMES[name] > 3){
						reject(response)
					}else{
						dispatch('getJssdkConfig',$wx)
					}
				})
			}
			
		})
	},
	getUiConfig({state,commit,dispatch}){
		let name = 'ui_config'
		return new Promise((resolve,reject)=>{
			Api.getUiConfig().then(data=>{
				console.log('----uiconfig')
				console.log(data)
				commit('setUiConfig',data)
				resolve(data)
			},msg=>{
				if(!RETRY_TIMES[name]){
					RETRY_TIMES[name] = 1
				}else{
					RETRY_TIMES[name]++
				}
				if(RETRY_TIMES[name] > 3){
					reject(msg)
				}else{
					dispatch('getUiConfig')
				}
				
			})
		})
	}
}


// WEBPACK FOOTER //
// ./src/store/actions.js